// Traduções específicas para a página de financiamento - Português (Brasil)
export const financingPt = {
  hero: {
    title: 'Financiamento',
    description:
      'Preencha o formulário para solicitar informações sobre nossas opções de financiamento.',
  },
  form: {
    firstName: 'Nome',
    lastName: 'Sobrenome',
    email: 'E-mail',
    phone: 'Telefone',
    rut: 'CPF', // BR: RUT → CPF
    birthDate: 'Data de Nascimento',
    employmentType: 'Atividade Profissional',
    monthlyIncome: 'Renda Líquida Mensal',
    vehicleInterest: 'Veículo de interesse',
    vehicleSearchPlaceholder: 'Buscar veículo',
    noVehiclesAvailable: 'No momento não há veículos disponíveis',
    downPayment: 'Valor da Entrada', // BR: pie → entrada
    message: 'Mensagem ou informações adicionais',
    submit: 'Enviar Informações',
  },
  employmentTypes: {
    employeeNonProfessional: 'Assalariado sem ensino superior', // BR: "Dependiente NO Profesional" (sem título universitário)
    employeeProfessional: 'Assalariado com ensino superior', // BR: "Dependiente Profesional" (com título universitário)
    selfEmployedNonProfessional: 'Autônomo sem ensino superior', // BR: "Independiente NO Profesional"
    selfEmployedProfessional: 'Autônomo com ensino superior', // BR: "Independiente Profesional"
    retired: 'Aposentado',
    other: 'Outros',
  },
  info: {
    optionsTitle: 'Opções de Financiamento',
    benefitsTitle: 'Benefícios do nosso financiamento',
    benefitsList: {
      item1: 'Taxas de juros competitivas',
      item2: 'Prazos flexíveis de 12 a 60 meses',
      item3: 'Aprovação rápida',
      item4: 'Poucos requisitos',
    },
    requirementsTitle: 'Requisitos básicos',
    requirementsList: {
      item1: 'Documento de identidade oficial válido',
      item2: 'Comprovante de residência',
      item3: 'Comprovante de renda',
      item4: 'Bom histórico de crédito',
    },
    directContactTitle: 'Contato Direto',
    emailLabel: 'E-mail',
    phoneLabel: 'Telefone',
  },
  embed: {
    infoTitle: 'Opções de financiamento',
    benefits: ['Aprovação rápida', 'Taxas competitivas', 'Prazos flexíveis', 'Sem letras miúdas'],
    requirementsTitle: 'Requisitos',
    requirements: [
      'Documento de identidade (RG ou CNH)', // BR: cédula de identidad → RG ou CNH
      'Comprovante de renda', // BR: liquidación de sueldo → comprovante de renda
      'Comprovante de residência',
      'Tempo mínimo de emprego',
    ],
    contactTitle: 'Contato direto',
  },
};
